import React, {useEffect, useState} from "react";
import {Collapse} from "react-bootstrap";
import {v4 as uuidv4} from "uuid";
import {PrescriptionReferralDetailResponseType} from "../../../../types/ihioPrescriptionFilling";
import {IhioReferencePrescriptionType} from "../../../../types/ihioPrescription";
import {useGetOrderedPrescription} from "../../../../hook/request/ihioPrescriptionFilling";
import OrderedPrescriptionItem
    from "../../ihioPrescriptionBill/orderedPrescriptionInfoModal/orderedPrescriptionItemCard";

type ReferralItemCardProps = {
    item: PrescriptionReferralDetailResponseType;
    nationalCode?: string;
}

const ReferralItemCard = ({
    item,
    nationalCode
}: ReferralItemCardProps) => {

    const [showCollapse, setShowCollapse] = useState<boolean>(false)
    const [orderedPrescriptionData, setOrderedPrescriptionData] = useState<IhioReferencePrescriptionType | null>(null)

    const getOrderedPrescriptionRequest = useGetOrderedPrescription()

    useEffect(() => {
        if(showCollapse) {
            getOrderedPrescriptionRequest.mutate({nationalCode: nationalCode, samadCode: item?.samadCode || ''})
        }
    }, [showCollapse]);

    useEffect(() => {
        if(getOrderedPrescriptionRequest?.isSuccess) {
            setOrderedPrescriptionData(getOrderedPrescriptionRequest?.data?.data?.result);
        }
    }, [getOrderedPrescriptionRequest?.isSuccess]);

    return (
        <div className={`card shadow-none border rounded-4 my-3`}>
            <div className={'card-body'}>
                <div className={'row row-cols-md-3 row-cols-2 mt-3'}>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 me-3'}>
                            کد سماد:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.samadCode || '-'}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 me-3'}>
                            نام همکار:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.contractpartyName || '-'}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 me-3'}>
                            تخصص:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.partnerName || '-'}
                        </span>
                    </div>
                </div>
                {item?.referralFeedback && (
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 me-3'}>
                            بازخورد:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.referralFeedback}
                        </span>
                    </div>
                )}
                <div className={'d-flex justify-content-end align-items-center cursor-pointer'}
                     onClick={() => setShowCollapse(!showCollapse)}
                >
                    <span
                        className={`d-flex align-items-center fw-semibold ${showCollapse ? 'text-primary' : 'text-gray-500'}`}>

                        {showCollapse ? 'مشاهده کمتر' : 'مشاهده بیشتر'}
                    </span>
                </div>
                <Collapse in={showCollapse}>
                    <div>
                        {orderedPrescriptionData?.items?.map((item) => {
                            const UUID = uuidv4()
                            return(
                                <OrderedPrescriptionItem
                                    key={UUID}
                                    item={item}
                                />
                            )
                        })}
                    </div>
                </Collapse>
            </div>
        </div>
    )
}


export default ReferralItemCard;